import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {GRID_LAYOUT} from '../constants';
import {Column} from '../Column';

export const Columns = ({columns, style, className, keepGridOnMobile, noMargin}) => {
    return (
        <Wrapper className={className} style={style} keepGridOnMobile={keepGridOnMobile}>
            {columns.map((column, index) => (
                <Fragment key={index}>

                    <Column
                        percentage={column.size ? column.size / GRID_LAYOUT : columns.length / GRID_LAYOUT}
                        css={column.css}
                        grow={column.grow}
                        shrink={column.shrink}
                        hideOnMobile={column.hideOnMobile}
                        keepGrid={keepGridOnMobile}
                        offsetPercentage={column.offset ? column.offset / GRID_LAYOUT : 0}
                        offsetRightPercentage={column.offsetRight ? column.offsetRight / GRID_LAYOUT : 0}
                        noMargin={noMargin}
                    >
                        {column.render()}
                    </Column>
                </Fragment>
            ))}
        </Wrapper>
    );
};

export const LimitedWidthColumns = styled(Columns)`
  max-width: 1080px;
  margin: 0 auto;
`;

Columns.propTypes = {
    columns: PropTypes.arrayOf(PropTypes.shape({
        size: PropTypes.number,
        render: PropTypes.func.isRequired,
        shrink: PropTypes.bool,
        grow: PropTypes.bool,
        css: PropTypes.array,
        offset: PropTypes.number,
        offsetRight: PropTypes.number,
        hideOnMobile: PropTypes.bool
    })).isRequired,
    className: PropTypes.string,
    style: PropTypes.object,
    keepGridOnMobile: PropTypes.bool,
    noMargin: PropTypes.bool
};

Columns.defaultProps = {
    style: {},
    keepGridOnMobile: false
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 768px) {
    display: ${props => props.keepGridOnMobile ? 'flex' : 'block'};
  }
  
  ${props => props.css}
`;

Wrapper.propTypes = {
    keepGridOnMobile: PropTypes.bool
};

export default Columns;

export const CenteredContent = ({children}) => (
    <Columns keepGridOnMobile={false} columns={[{
        size: 6,
        shrink: false,
        grow: false,
        offset: 3,
        render: () => children
    }]}/>
);

CenteredContent.propTypes = {
    children: PropTypes.element
};
